export class ControlledDocumentUploadIntent {
  // used as a *value* placeholder for the file-upload component to know that it should start uploading files
  public constructor(public files: Array<File>) {
  }

}